"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ApiManagerAdmin_1 = require("../ApiManagerAdmin");
var ApiConfig_1 = require("../config/ApiConfig");
var ApiProduct = /** @class */ (function (_super) {
    __extends(ApiProduct, _super);
    function ApiProduct() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.CHANGE_PRODUCT_SORT = "/api/product/sort";
        _this.GET_PRODUCT_NEW_ID = "/api/product/getNewId";
        _this.GET_PRODUCT_ITEM = "/api/product/getProduct"; // EDIT시 호출
        _this.ADD_PRODUCT_ITEM = "/api/product/addProduct"; // CREATE시 호출
        _this.UPDATE_PRODUCT_ITEM = "/api/product/updateProduct";
        _this.GET_GROUPS_GOODS = "/api/product/newProduct"; // 상품그룹, 굿즈목록 받아오기
        _this.GET_PRODUCT_LIST = "/api/product/getList";
        _this.GET_LOCALE_LIST = "/api/locale/getLocaleList";
        /**
         * 작가 생성
         * @param accesstoken
         * @param language
         * @param name
         * @returns
         */
        _this.getProductNewId = function (accesstoken, language) {
            var data = {
                language: language,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                url: _this.GET_PRODUCT_NEW_ID,
                method: "post",
                data: data,
            });
            return config;
        };
        _this.getGroupAndGoods = function (accesstoken, language, productIds) {
            var data = {
                language: language,
                productIds: productIds,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                url: _this.GET_GROUPS_GOODS,
                method: "post",
                data: data,
            });
            return config;
        };
        _this.saveSort = function (accesstoken, language, productIds) {
            var data = {
                language: language,
                productIds: productIds,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                url: _this.CHANGE_PRODUCT_SORT,
                method: "post",
                data: data,
            });
            return config;
        };
        _this.getProductList = function (accesstoken, language, productType) {
            if (productType === void 0) { productType = "NORMAL"; }
            var data = {
                language: language,
                productType: productType,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                url: _this.GET_PRODUCT_LIST,
                method: "post",
                data: data,
            });
            return config;
        };
        _this.getLocaleList = function (accesstoken) {
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                url: _this.GET_LOCALE_LIST,
                method: "get",
            });
            return config;
        };
        _this.getProductItem = function (accesstoken, language, productId) {
            var data = {
                language: language,
            };
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                url: "".concat(_this.GET_PRODUCT_ITEM, "/").concat(productId),
                method: "post",
                data: data,
            });
            return config;
        };
        _this.addProductItem = function (accesstoken, request) {
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                url: _this.ADD_PRODUCT_ITEM,
                method: "post",
                data: request,
            });
            return config;
        };
        _this.updateProductItem = function (accesstoken, request, productId) {
            var config = ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                url: "".concat(_this.UPDATE_PRODUCT_ITEM, "/").concat(productId),
                method: "post",
                data: request,
            });
            return config;
        };
        return _this;
    }
    ApiProduct.getInstance = function (initValue) {
        if (!ApiProduct.classInstance) {
            this.classInstance = new ApiProduct(initValue);
        }
        return this.classInstance;
    };
    return ApiProduct;
}(ApiManagerAdmin_1.ApiManager));
exports.default = ApiProduct;
